/**
 * The state a redesigned Workflow page keeps for ONE WorkflowNotice (Workflow overhaul P6, 2026-10-10).
 *
 *   showNotice({ kind, title, text, actionLabel }, onAction)  replaces whatever notice is up
 *   closeNotice()                                             the close button, the 4 seconds, a new attempt
 *   runNoticeAction()                                         the action button: close first, then run it
 *
 * `onAction` lives here, outside the notice object, because the notice is plain data for a presentational
 * component. Closing before running means a "Try again" that fails shows its own new notice instead of being
 * cleared by this one.
 *
 * ⛔ Pages draw the notice with `<WorkflowNotice :notice="notice" @action="runNoticeAction" @close="closeNotice" />`.
 */
export default {
  data() {
    return {
      notice: null,
      noticeAction: null,
    };
  },

  methods: {
    showNotice(notice, onAction) {
      this.notice = notice || null;
      this.noticeAction = notice && typeof onAction === 'function' ? onAction : null;
    },

    closeNotice() {
      this.notice = null;
      this.noticeAction = null;
    },

    runNoticeAction() {
      const action = this.noticeAction;
      this.closeNotice();
      if (action) action();
    },
  },
};
